const AuthValidateData = props => {
  const { tab, phone, password, errorPhone, errorPassword, getCode, agreementAccepted, personalDataAccepted } = props;

  const cleanPhone = phone
    ? phone.replace(/[/+()_-]*/g, '').replace(/\s/g, '')
    : '';

  // Проверка чекбоксов для вкладок auth и reg
  const checkboxesValid = tab === 'auth' || tab === 'reg' 
    ? agreementAccepted && personalDataAccepted 
    : true;

  switch (tab) {
    case 'auth':
      if (errorPhone) {
        if (cleanPhone.length === 11 && checkboxesValid) {
          return true;
        }
      } else if (
        cleanPhone.length === 11 &&
        password.length >= 6 &&
        !errorPassword &&
        checkboxesValid
      ) {
        return true;
      }
      return false;

    case 'reg':
      if (getCode) {
        if (cleanPhone.length === 11 && password.length > 3 && !errorPassword && checkboxesValid) {
          return true;
        }
      } else {
        if (cleanPhone.length === 11 && checkboxesValid) {
          return true;
        }
      }
      return false;

    case 'forget':
      if (getCode) {
        if (cleanPhone.length === 11 && password.length > 3 && !errorPassword) {
          return true;
        }
      } else {
        if (cleanPhone.length === 11) {
          return true;
        }
      }
      return false;

    default:
      return false;
  }
};

export default AuthValidateData;
